<ap-selector-modal-single
    [showIcons]="true"
    [options]="displayOptions"
    (selected)="select($event)"
    data-testid="selector-single"
></ap-selector-modal-single>
